import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import TranslationProvider from '../../providers/TranslationProvider'
import SuccessIcon from '../../../../assets/images/vendors/icons/success.svg'
import { search_with_params_vendors_path, vendor_path } from '../../../routes.js.erb'
import LeadIntakeVendorItem from './LeadIntakeVendorItem'

interface IntakeSuccessProps {
  locale: string
  locationSlug: string
  categorySlug: string
  relatedVendors: any[]
}

export default class LeadIntakeSuccessApp extends Component {
  locale: string
  locationSlug: string
  categorySlug: string
  relatedVendors: any[]

  constructor (props: IntakeSuccessProps) {
    super(props)

    this.locale = props.locale
    this.locationSlug = props.locationSlug
    this.categorySlug = props.categorySlug
    this.relatedVendors = props.relatedVendors
  }

  render () {
    return (
            <div className="intake_success p-3 d-flex flex-column align-items-center justify-content-center mt-4">
                <TranslationProvider user_locale={this.locale}>
                    <div className="text-center success_message-block">
                        <img width="124px" height="124px" src={SuccessIcon}/>
                        <h2 className="mt-3">
                            <FormattedMessage id='intake.success.title' defaultMessage=
                                'Your request has been sent to the appropriate printing houses.'/>
                        </h2>
                        <p className="mt-3">
                            <FormattedMessage id='intake.success.desc' defaultMessage=
                                'Printing house representatives will contact you shortly!'/>

                        </p>
                        <div className="actions">
                            <a href={search_with_params_vendors_path(this.locale, this.locationSlug, this.categorySlug)}>
                                <button className="main_submit mt-5" type="button">
                                    <FormattedMessage id='intake.success.see_all' defaultMessage=
                                        'View all printing houses'/>
                                </button>
                            </a>
                        </div>
                    </div>
                    <div className="vendors_block text-center mt-5">
                        <h2 className="mt-3">
                            <FormattedMessage id='intake.success.add_title' defaultMessage=
                                'Your application has been sent to %{count} printing houses in %{city}.'
                                              values={{
                                                count: this.relatedVendors.length,
                                                city: <FormattedMessage id={`locations.short_form.${this.locationSlug}`}
                                                                          defaultMessage=
                                                                              'Astana'/>
                                              }}/>
                        </h2>
                        <p className="mt-1">
                            <FormattedMessage id='intake.success.add_desc' defaultMessage=
                                'You can also contact them at your convenience'/>
                        </p>
                    </div>
                    <div className="w-100">
                        <div className="vendor_list d-flex align-items-center justify-content-center flex-wrap">
                            {this.relatedVendors.map((relatedVendor) => (
                                <a
                                    key={relatedVendor.slug}
                                    rel="noreferrer"
                                    target="_blank"
                                    href={vendor_path(this.locale, relatedVendor.slug)}
                                >
                                    <LeadIntakeVendorItem vendor={relatedVendor} />
                                </a>
                            ))}

                        </div>
                    </div>
                </TranslationProvider>
            </div>
    )
  }
}
